import React, {
  useEffect,
  useState,
  Fragment,
  useContext,
  useRef,
} from "react";
import MaskedInput from "react-text-mask";
import { preSignup, resendCode, signup } from "../api/userApi";
import "./Home.css";
import Modal from "react-modal";
import ReactInputVerificationCode from "react-input-verification-code";
import UserContext from "../contexts/user-context";
import { sites } from "../sites";
import LoadingContext from "../contexts/loading-context";
import ErrorContext from "../contexts/error-context";
import CountDown from "../Shared/CountDown";

export default function Home(props) {
  const [subscriptions, setSubscriptions] = useState(sites);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [codeId, setCodeId] = useState("");
  const [isConsent, setConsent] = useState(false);

  const [verificationModalOpen, setVerificationModalOpen] = useState(false);
  const { handleUserSignIn } = useContext(UserContext);
  const { setIsLoading } = useContext(LoadingContext);
  const { showErrorModal } = useContext(ErrorContext);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");

  function isPhoneValid() {
    if (phone.match(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)) {
      return true;
    }

    return false;
  }

  function isNameValid() {
    const textRegex = /^[a-zA-Z ]*$/;
    if (name.trim() != "" && name.match(textRegex)) {
      return true;
    }

    return false;
  }

  function canSubmit() {
    return isConsent && isPhoneValid() && isNameValid();
  }

  function submit(e) {
    e.preventDefault();
    const trimmedPhone = phone.replace(/[^\d]/g, "");
    setIsLoading(true);
    preSignup({ phone: trimmedPhone })
      .then((res) => {
        setCodeId(res.data.data);
        setIsLoading(false);

        setVerificationModalOpen(true);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response && err.response.status === 409) {
          setError("Phone number exists, please use another one.");
        } else if (err.response && err.response.status === 401) {
          setError(
            "We are sorry but this phone number did not sign up for testing."
          );
        } else {
          setError(
            "There is an error. Please refresh and try again or Contact us"
          );
        }
      });
  }

  async function verifyPhone(e, code) {
    e.preventDefault();
    setIsLoading(true);

    const trimmedPhone = phone.replace(/[^\d]/g, "");
    await signup({
      code,
      codeId,
      phone: trimmedPhone,
      subscriptions,
      name,
    }).then(
      (res) => {
        setIsLoading(false);

        if (res.data.success) {
          setVerificationModalOpen(false);
          handleUserSignIn(res.data);
        }
      },
      (err) => {
        setIsLoading(false);

        console.error("wrong code");
        if (err.response && err.response.status === 401) {
          setModalError("Verification code is incorrect.");
        } else {
          setModalError(
            "There is an error. Please refresh and try again or Contact us"
          );
        }
      }
    );
  }

  async function resend(e) {
    e.preventDefault();
    const trimmedPhone = phone.replace(/[^\d]/g, "");

    await resendCode(trimmedPhone).then((res) => {
      if (res.data.success) {
        setCodeId(res.data.data);
      }
    });
  }

  return (
    <div className="container">
      <h1>Squishmallows for everyone</h1>
      <div>
        Sign up to get alerted via text messages when Squishmallows sites
        restock. Never miss out a restock anymore ^.^
      </div>
      <br />
      <div>
        <div class="form-group">
          <label for="exampleInputEmail1">
            Name<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            aria-describedby="name"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <small class="form-text text-muted">
            We don't care if you use your fake name
          </small>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">
            Enter your phone number<span className="text-danger">*</span>
          </label>
          <MaskedInput
            mask={[
              "(",
              /[1-9]/,
              /\d/,
              /\d/,
              ")",
              " ",
              /\d/,
              /\d/,
              /\d/,
              "-",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ]}
            className="form-control"
            placeholder="Enter your phone number"
            guide={false}
            id="phone=number"
            // onBlur={() => {}}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            value={phone}
          />
          <small class="form-text text-muted">
            We'll never share your phone number with anyone else.
          </small>
        </div>
        <div>
          Which sites do you want to receive alerts from? (check at least one)
        </div>
        <div
          style={{
            columns: 2,
            padding: "20px",
            margin: "10px",
            background: "rgba(243, 241, 239, 0.7)",
          }}
        >
          {subscriptions.map((s, i) => {
            return (
              <label className="checkbox-container">
                {s.name}
                <input
                  type="checkbox"
                  checked={s.checked}
                  onChange={() => {
                    console.log();
                    setSubscriptions(
                      subscriptions.map((item, index) =>
                        index === i ? { ...item, checked: !item.checked } : item
                      )
                    );
                  }}
                  disabled={s.disabled}
                />
                <span className="checkbox-checkmark"></span>
                {s.disabled && (
                  <small class="form-text text-muted">coming soon</small>
                )}
              </label>
            );
          })}
        </div>

        <label className="checkbox-container">
          <span className="font-weight-bold">
            <span className="text-danger">*</span>
            By signing up, you agree to receive text messages from us
          </span>
          <input
            type="checkbox"
            checked={isConsent}
            onChange={() => setConsent((e) => !e)}
          />
          <span className="checkbox-checkmark"></span>
        </label>
        {error != "" && <div className="text-danger mb-1">{error}</div>}

        <div>
          <button
            className="btn btn-success"
            onClick={submit}
            disabled={!canSubmit()}
          >
            Sign up
          </button>
        </div>
        <VerificationModal
          isVisible={verificationModalOpen}
          setVisible={setVerificationModalOpen}
          verifyPhone={verifyPhone}
          error={modalError}
          setError={setModalError}
          resend={resend}
        />
      </div>
    </div>
  );
}

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root");

function VerificationModal(props) {
  const { isVisible, setVisible, verifyPhone, error, setError, resend } = props;
  const [code, setCode] = useState("");
  const [isTimeUp, setTimeUp] = useState(false);

  function reset() {
    setCode("");
  }

  function timeUp() {
    console.log("timeup");
    setTimeUp(true);
    setError("Time's up. Please send another code");
    // setShowVerification(false);
  }

  function reset() {
    setCode("");
    // setPhone("");
    // setCodeId("");
    setTimeUp(false);
    setError("");
  }

  async function resendCode(e) {
    await resend(e);
    setTimeUp(false);
  }

  return (
    // <button onClick={openModal}>Open Modal</button>
    <Modal
      isOpen={isVisible}
      // onAfterOpen={afterOpenModal}
      onRequestClose={() => setVisible(false)}
      style={{
        ...customStyles,
        content: { ...customStyles.content, maxWidth: "calc(100% - 10px)" },
      }}
      contentLabel="Verification Code"
    >
      <button className="btn modal-close-btn" onClick={() => setVisible(false)}>
        <i className="fas fa-times"></i>
      </button>
      <h2>Verify your phone number</h2>
      <div>
        Please insert the 6-digit verification code we sent to your phone number
      </div>
      {/* <CountDown timeUp={timeUp} /> */}
      <div className="verification-code">
        <ReactInputVerificationCode
          length={6}
          onChange={setCode}
          value={code}
        />
      </div>
      {error != "" && <div className="text-danger mb-1">{error}</div>}
      <button className="btn" onClick={reset}>
        Reset
      </button>
      {/* {isTimeUp ? (
        <button className="btn btn-primary" onClick={resendCode}>
          Resend code
        </button>
      ) : ( */}
      <button className="btn btn-success" onClick={(e) => verifyPhone(e, code)}>
        Verify and Sign up
      </button>
      {/* )} */}
    </Modal>
  );
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "700px",
  },
};
